__webpack_require__.p = "https://previewer-assets.adalo.com/";